import { TextField } from '@material-ui/core';
import { LocalDate } from '@spa-frontend/date-lib';
import { observer } from 'mobx-react';
import React from 'react';

import { CancelContractManualRequestDto } from '../../../core/api/dtos';
import { WrappedField } from '../../../core/common/forms';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { SharedContractDissolutionStore } from '../../shared-contract-dissolution-store';
import { StyledBlackLabel } from '../../styles';

interface ManualDatePickerProps {
    cancellationDateField: WrappedField<
        CancelContractManualRequestDto['cancellationDate']
    >;
    cancellationDateType: CancelContractManualRequestDto['cancellationDateType'];
}

export const ManualDatePicker = observer((props: ManualDatePickerProps) => {
    const { translate } = injectTSDI(I18n);
    const { cancellationDateField, cancellationDateType } = props;
    const { updateDateIfValid } = injectTSDI(SharedContractDissolutionStore);

    return (
        <TextField
            fullWidth
            type="date"
            data-role="manual-contract-termination-date"
            inputProps={{ min: LocalDate.now().addDays(1) }}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            label={
                <StyledBlackLabel>
                    {translate(
                        'public.content.terminate.contract.absolute.cancellation.date'
                    )}
                </StyledBlackLabel>
            }
            value={cancellationDateField.value?.toString() || ''}
            onChange={(event) =>
                updateDateIfValid(event, cancellationDateField)
            }
            error={
                cancellationDateType === 'ABSOLUTE_CANCELLATION_DATE' &&
                Boolean(cancellationDateField.error)
            }
            helperText={
                cancellationDateType === 'ABSOLUTE_CANCELLATION_DATE'
                    ? translate(cancellationDateField.error)
                    : undefined
            }
            required={cancellationDateType === 'ABSOLUTE_CANCELLATION_DATE'}
        />
    );
});
